(function () {
  'use strict';

  /* @ngdoc object
   * @name crewHourReport
   * @description
   *
   */
  angular
    .module('crewHourReport', [
      'ui.router'
    ]);
}());
